import { createReducer, Action, on } from '@ngrx/store';

import { LiveGalleryTab } from '@live/pages/live-gallery-page/interfaces';

import * as LiveGalleryActions from '../actions/live-gallery.actions';

export interface State {
  selectedTab: LiveGalleryTab;
}

const initialState: State = {
  selectedTab: LiveGalleryTab.PINNED
};

const viewReducer = createReducer(
  initialState,
  on(LiveGalleryActions.selectTab, (state, { tab }) => {
    return {
      ...state,
      selectedTab: tab
    };
  }),
  on(LiveGalleryActions.selectView, (state, { view }) => {
    return {
      ...state,
      view: view
    };
  })
);

export function reducer(state: State | undefined, action: Action) {
  return viewReducer(state, action);
}
